/**
 * Returns the configured invoice value tolerance delta (₹).
 * Reads from window.config.AUTO_VALIDATION_CONFIG.INVOICE_VAL_DELTA, falling
 * back to ₹10 when the config key is absent (matches backend absolute tolerance).
 *
 * Shared by EditInvoice (field-level auto-validation) and ThreeWayMatchCard
 * (UI-side amount row Result tag) so both surfaces use the same threshold.
 */
export function getInvoiceValueDelta(): number {
  try {
    return (window as any).config?.AUTO_VALIDATION_CONFIG?.INVOICE_VAL_DELTA ?? 10;
  } catch {
    return 10;
  }
}
